var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluearrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.410823 0.744075C0.736265 0.418642 1.2639 0.418642 1.58934 0.744075L6.00008 5.15483L10.4108 0.744075C10.7362 0.418642 11.2639 0.418642 11.5893 0.744075C11.9147 1.06952 11.9147 1.59717 11.5893 1.92258L6.58933 6.92258C6.26391 7.248 5.73625 7.248 5.41083 6.92258L0.410823 1.92258C0.0853897 1.59717 0.0853897 1.06952 0.410823 0.744075Z",
    fill: "#533E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluearrow);
export default __webpack_public_path__ + "static/media/blue arrow.ffc680f1a06bfed10c4bcc6024275441.svg";
export { ForwardRef as ReactComponent };